import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = ProjectTour[];

export const getProjectsTour = createAppAsyncThunk(
  'projectTour/getProjectsTour',
  async (
    _,
    { extra: { projectTourGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const projects = await projectTourGateway.getAll();
      return projects;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetProjects.Message.error'));
}
